/* @flow */

import exibirErroUpload from './exibir-erro-upload';
import MENSAGENS from '../mensagens';
import { DIRETORIO_IMAGENS_UPLOAD } from '../utils/constants';
import uploadFile from '../utils/upload-file';
import { exibirToastSucesso } from '../utils/alertas';
import previewImagem from '../utils/preview-imagem';
import getInputPorId from '../utils/get-input-por-id';

const logo = async (file: File, url: string) => {
    try {
        getInputPorId('logo-empresa').value = '';
        const { data } = await uploadFile(file, url);
        previewImagem.set('.m-card-profile__pic-wrapper img', `${DIRETORIO_IMAGENS_UPLOAD}${data.link}`);
    } catch (erro) {
        previewImagem.remover('.logo-empresa');
        exibirErroUpload(erro, MENSAGENS.EMPRESA.APLICATIVO.UPLOAD.LOGO.ERRO);
    }
};

const imagemFundo = async (file: File, url: string) => {
    try {
        getInputPorId('imagem-fundo-empresa').value = '';
        const { data } = await uploadFile(file, url);
        previewImagem.set('.imagem-fundo-empresa', `${DIRETORIO_IMAGENS_UPLOAD}${data.link}`);
    } catch (erro) {
        previewImagem.remover('.imagem-fundo-empresa');
        exibirErroUpload(erro, MENSAGENS.EMPRESA.APLICATIVO.UPLOAD.IMAGEM_FUNDO.ERRO);
    }
};

const capaWeb = async (file: File, url: string) => {
    try {
        getInputPorId('imagem-capa-web-loja').value = '';
        const { data } = await uploadFile(file, url);
        previewImagem.set('.imagem-capa-web-loja', `${DIRETORIO_IMAGENS_UPLOAD}${data.link}`);
        exibirToastSucesso('Capa salva com sucesso');
    } catch (erro) {
        previewImagem.remover('.imagem-capa-web-loja');
        exibirErroUpload(erro, 'Não foi possível enviar a imagem de capa da web');
    }
};

export default { logo, imagemFundo, capaWeb };
